import { render } from "./TwInput.vue?vue&type=template&id=74aa9087&scoped=true"
import script from "./TwInput.vue?vue&type=script&lang=js"
export * from "./TwInput.vue?vue&type=script&lang=js"

import "./TwInput.vue?vue&type=style&index=0&id=74aa9087&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74aa9087"

export default script